import { TextField } from 'components/Form';
import BaseModal from 'components/modals/BaseModal';
import { fillFields } from 'helper/InputField';
import { getDate } from 'helper/date';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { NATIONALITY } from 'utils/constants';
import * as S from './ModalKidsDetail.styles';
import { ContentProps, KidsProps } from './modalKidsDetail.interface';

const Content = ({ open, closeModal, kid }: ContentProps) => {
  const { t } = useTranslation();

  const { register, setValue, getValues } = useForm<any>();

  useEffect(() => {
    if (kid) {
      fillInputs(kid);
    }
  }, [kid]);

  const fillInputs = (kid: KidsProps): void => {
    if (!kid) return;

    const {
      enFname,
      enLname,
      nationality,
      birthdate,
      nationalId,
      address,
      personId,
      title,
      docId,
      docExpireDate,
      email,
      mobile,
      zipCode,
      passportIssuingCountry,
    } = kid;

    fillFields(
      {
        enFname,
        enLname,
        nationality,
        birthdate: getDate(birthdate, 'YYYY-MM-DD'),
        passportIssuingCountry,
        nationalId,
        address,
        personId,
        zipCode,
        title,
        docId,
        docExpireDate: getDate(docExpireDate, 'YYYY-MM-DD'),
        email,
        mobile,
      },
      setValue
    );
  };

  if (!kid) return null;
  console.log(
    NATIONALITY.find((c) => {
      return c.value === kid.passportIssuingCountry && c.title;
    })
  );
  const defaultValueNationality = NATIONALITY.find((c) => {
    return c.value === kid.nationality && c.title;
  });
  const defaultValuePassportCountry = NATIONALITY.find((c) => {
    return c.value === kid.passportIssuingCountry && c.title;
  });
  return (
    <S.Wrapper>
      <S.KidBoxTitleMargin>{t('pages.kids.form.title')}</S.KidBoxTitleMargin>
      <S.KidFormInputWrapper>
        <S.TextFieldKid
          as={TextField}
          control={register('enFname')}
          label={t('pages.kids.form.fields.firstName')}
          disabled={true}
        />
        <S.TextFieldKid
          as={TextField}
          control={register('enLname')}
          label={t('pages.kids.form.fields.lastName')}
          disabled={true}
        />
        <S.TextFieldKid
          as={TextField}
          // control={register('nationality')}
          label={t('pages.kids.form.fields.nationality')}
          disabled={true}
          defaultValue={defaultValueNationality?.title}
        />

        <S.TextFieldKid
          as={TextField}
          control={register('title')}
          label={t('pages.kids.form.fields.title')}
          disabled={true}
        />
        <S.TextFieldKid
          as={TextField}
          // control={register('passportIssuingCountry')}
          label={t('pages.kids.form.fields.passportCountry')}
          disabled={true}
          defaultValue={defaultValuePassportCountry?.title}
        />
        <S.TextFieldKid
          as={TextField}
          control={register('birthdate')}
          label={t('pages.kids.form.fields.birthdate')}
          disabled={true}
          dir="ltr"
        />
        <S.TextFieldKid
          as={TextField}
          control={register('personId')}
          label={t('pages.kids.form.fields.personId')}
          disabled={true}
          dir="ltr"
        />

        <TextField
          dir="ltr"
          control={register('docId')}
          label={t('pages.kids.form.fields.passportNo')}
          disabled={true}
        />
      </S.KidFormInputWrapper>
    </S.Wrapper>
  );
};

interface State {
  open: boolean;
  kid: KidsProps | null;
}

interface Props {
  ref: any;
}

class ModalKidsDetail extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
      kid: null,
    };
  }

  openModal = (kid: KidsProps): void => this.setState({ open: true, kid });

  closeModal = (): void => this.setState({ open: false });

  render() {
    return (
      <S.KidsDetailModalContainer as={BaseModal} open={this.state.open} closeModal={this.closeModal}>
        {this.state.kid ? (
          <Content {...this.props} open={this.state.open} closeModal={this.closeModal} kid={this.state.kid} />
        ) : null}
      </S.KidsDetailModalContainer>
    );
  }
}

export default ModalKidsDetail;
